import _ from "lodash";
import { date } from "@/components/mixins/date";

import { mapProductionStateColors } from "@/common/constants";
import streamApi from "@/api/streamApi";

export default {
  state: {
    last: {},
    timelineAll: [],
    timelineLastPoint: {},
    timelineEventsAll: [],
    timelineEventsLastPoint: {},
    repsTarget: {},
    repsDone: {}
  },
  getters: {
    getLast: state => state.last,
    getTimelineLastPoint: state => state.timelineLastPoint,
    getTimelineAll: state => state.timelineAll,
    getTimelineEventsLastPoint: state => state.timelineEventsLastPoint,
    getTimelineEventsAll: state => state.timelineEventsAll,
    getRepsTarget: state => state.repsTarget,
    getRepsTargetLast: state => state.repsTargetLast,
    getRepsDone: state => state.repsDone,
    getRepsDoneLast: state => state.repsDoneLast
  },
  actions: {
    subscribe: ({ dispatch }) => {
      dispatch("subscribeProductionStatus", null);
    },

    subscribeProductionStatus: ({ state, dispatch, commit, rootGetters }) => {
      const m = rootGetters["Machine/getSelected"];
      const idForStreamApi = m.Id;

      const isCms = m.TicketManager && m.TicketManager === "CMS";

      const date_from = new Date();
      date_from.setHours(0);
      date_from.setMinutes(0);
      date_from.setSeconds(0);

      if (!isCms) {
        streamApi.retrieveHistorical(
          idForStreamApi,
          "ProductionStatus/timeline",
          { after: date_from, before: new Date(Date.now()) },
          function (arr) {
            try {
              if (!!arr && arr.length > 0) {
                // Commit series
                commit("ADD_SERIES", arr);
              }
              const eval_date_from = date_from;

              // Sub latest Timeline Status
              let evalLastTimePoint = false;
              setTimeout(function () {
                streamApi.subLatest(idForStreamApi, "ProductionStatus/timeline", function (pub) {
                  // latest after daily dateFrom
                  if (date.methods.diffInDays(pub.data.ts, eval_date_from) > 0) {
                    if (state.timelineAll.length > 0) {
                      commit("UPDATE_LAST", pub.data);

                      if (!evalLastTimePoint) {
                        evalLastTimePoint = true;
                      } else {
                        // Update serie
                        commit("UPDATE_SERIE_VAL", pub);
                      }
                    } else {
                      // Commit series
                      commit("ADD_SERIES", new Array(pub));
                    }
                  }
                });
              }, 20);
            } catch (e) {
              console.error(e);
            }
          }
        );
      } else {
        // CMS M154 NOTIFICATION temp
        streamApi.retrieveHistorical(
          idForStreamApi,
          "Machine/ProductionProcesses/01/Notification",
          { after: date_from },
          function (arr) {
            //if (!!arr && arr.length > 0) {
            //debugger;
            // Commit series
            arr.forEach(function (element) {
              element.channel = "Machine/ProductionProcesses/01/Notification";
            });
            let lastProgram;
            streamApi.retrieveHistorical(
              idForStreamApi,
              "Machine/ProductionProcesses/01/Programs/01/Name",
              { after: date_from },
              function (arr2) {
                //if (!!arr && arr.length > 0) {
                // Commit series
                arr2.forEach(function (element) {
                  element.channel = "Machine/ProductionProcesses/01/Programs/01/Name";
                });
                const value = arr2[arr2.length - 1] || {};
                lastProgram = value.v;
                const arrTot = arr.concat(arr2);
                arrTot.sort((a, b) => (a.ts < b.ts ? 1 : b.ts < a.ts ? -1 : 0));
                commit("ADD_SERIES_EVENT", arrTot);

                // Sub latest
                let evalLastTimePointNotification = false;
                let evalLastTimePointCP = false;
                setTimeout(function () {
                  streamApi.subLatest(
                    idForStreamApi,
                    "Machine/ProductionProcesses/01/Notification",
                    function (pub) {
                      if (!evalLastTimePointNotification) {
                        evalLastTimePointNotification = true;
                      } else {
                        // Update serie
                        //pub.channel = "Machine/ProductionProcesses/01/Notification";
                        pub.currProg = lastProgram;
                        commit("UPDATE_SERIE_EVENT_VAL", pub);
                      }
                    }
                  );
                  streamApi.subLatest(
                    idForStreamApi,
                    "Machine/ProductionProcesses/01/Programs/01/Name",
                    function (pub) {
                      if (!evalLastTimePointCP) {
                        evalLastTimePointCP = true;
                      } else {
                        // Update serie
                        //pub.channel = "Machine/ProductionProcesses/01/Programs/01/Name";
                        lastProgram = pub.v;
                        pub.currProg = pub.v;
                        commit("UPDATE_SERIE_EVENT_VAL", pub);
                      }
                    }
                  );
                }, 20);
              }
            );
          }
        );
        dispatch("subscribeProductionReps", null);
      }
    },

    subscribeProductionReps: ({ commit, rootGetters }) => {
      const m = rootGetters["Machine/getSelected"];
      const idForStreamApi = m.Id;

      const date_from = new Date();
      date_from.setHours(0);
      date_from.setMinutes(0);
      date_from.setSeconds(0);

      streamApi.retrieveHistorical(
        idForStreamApi,
        "Machine/ProductionProcesses/01/Programs/01/RepsTarget",
        { after: date_from },
        function (arr) {
          if (!!arr && arr.length > 0) {
            //debugger;
            // Commit series
            commit("ADD_REPS_TARGET", arr[0]);
            // Sub latest
            let evalLastTimePoint = false;
            setTimeout(function () {
              streamApi.subLatest(
                idForStreamApi,
                "Machine/ProductionProcesses/01/Programs/01/RepsTarget",
                function (pub) {
                  if (!evalLastTimePoint) {
                    evalLastTimePoint = true;
                  } else {
                    // Update serie
                    commit("UPDATE_REPS_TARGET", pub.data);
                  }
                }
              );
            }, 20);
          }
        }
      );
      streamApi.retrieveHistorical(
        idForStreamApi,
        "Machine/ProductionProcesses/01/Programs/01/RepsDone",
        { after: date_from },
        function (arr) {
          if (!!arr && arr.length > 0) {
            //debugger;
            // Commit series
            commit("ADD_REPS_DONE", arr[0]);
            // Sub latest
            let evalLastTimePoint = false;
            setTimeout(function () {
              streamApi.subLatest(
                idForStreamApi,
                "Machine/ProductionProcesses/01/Programs/01/RepsDone",
                function (pub) {
                  if (!evalLastTimePoint) {
                    evalLastTimePoint = true;
                  } else {
                    // Update serie
                    commit("UPDATE_REPS_DONE", pub.data);
                  }
                }
              );
            }, 20);
          }
        }
      );
    },

    unsubscribe: ({ commit, rootGetters }) => {
      streamApi.unsub(
        rootGetters["Machine/getSelected"].Id,
        "ProductionStatus/timeline",
        function () {}
      );

      commit("RESET");
    }
  },
  mutations: {
    UPDATE_SERIE_VAL: (state, payload) => {
      try {
        const v = !!payload.data && !!payload.data.v ? payload.data.v : false;
        if (v.ref) {
          const newPoint = [];
          const ts = new Date(v.ts).getTime();

          let y_value = "--"; //isNaN(Math.floor(Number(v))) ? v : Math.floor(Number(v));
          if (v.Status) {
            y_value = v.Status;
          } else if (v.status) {
            // old dataModel
            y_value = v.status;
          }
          newPoint.push(ts);
          newPoint.push(y_value);

          // Update timeline Last Point
          state.timelineLastPoint = {
            ref_channel: v.ref,
            data: newPoint
          };

          // Add original other info
          const pubData = {};
          // Old Data model
          if (v.name) {
            pubData.Name = v.name;
          }
          if (v.Name) {
            pubData.Name = v.Name;
          }
          const findSerie = state.timelineAll.find(item => item.ref_channel === v.ref);
          if (findSerie) {
            // Add to serie
            if (isNaN(newPoint[0])) {
              newPoint[0] = date.methods.objDateToday().toISOString();
            }
            findSerie.serie.data.push(newPoint);

            if (pubData.Name) {
              pubData.Area = findSerie.serie.name;
            }
            findSerie.serie.originalData.push(pubData);
          } else {
            // Add serie
            const name_serie =
              v.ref.indexOf("/") > -1 ? "Process:" + state.timelineAll.length + 1 : v.ref;
            if (pubData.Name) {
              pubData.Area = name_serie;
            }
            const newSerie = {
              serie: {
                name: name_serie,
                data: new Array(newPoint), // [ [ts, value], [ts, value] ..... ]
                originalData: new Array(pubData),
                eventsData: [],
                id: v.ref.replace(new RegExp("/", "g"), "_")
              },
              ref_channel: v.ref,
              colors: mapProductionStateColors,
              ref_label: v.ref.replace(new RegExp("/", "g"), "_")
            };

            state.timelineAll.push(newSerie);
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    UPDATE_SERIE_EVENT_VAL: (state, payload) => {
      // Update serie EVENT
      if (!!payload && !!payload.channel) {
        const findSerie = state.timelineEventsAll[0];
        if (!!findSerie && payload.data.v) {
          const ts = new Date(payload.data.ts).getTime();

          let title;
          let currProg;
          let notification;
          if (payload.channel.includes("Notification")) {
            title = "N";
            currProg = payload.currProg;
            notification = payload.data.v;
          } else if (payload.channel.includes("Name")) {
            title = "CP";
            currProg = payload.data.v;
            notification = "";
          }
          const newPoint = {
            x: ts,
            title,
            text: "<b>M154 CODE</b><br>" + payload.data.v + "<br>" + date.methods.getLocalTime(ts),
            original: payload.data.v,
            currProg,
            notification
          };

          state.timelineEventsLastPoint = {
            ref: payload.channel,
            topic: payload.channel.replace(new RegExp("/", "g"), "_"), // replace all
            point: newPoint
          };

          findSerie.serie.eventsData.push(newPoint);
        }
      }
    },
    ADD_SERIES: (state, payload) => {
      const tmp_timelineAll = [];
      for (let i = 0; i < payload.length; i++) {
        if (payload[i].data.v) {
          const v = payload[i].data.v;

          if (v.ref) {
            const newPoint = [];
            const ts = new Date(payload[i].data.ts).getTime();
            let y_value = "--"; //isNaN(Math.floor(Number(v))) ? v : Math.floor(Number(v));
            const pubData = {}; // Add original other info

            if (v.Status) {
              y_value = v.Status;
            } else if (v.status) {
              // old dataModel
              y_value = v.status;
            }
            newPoint.push(ts);

            // Wrap EXE until DONE state
            /*
            if (y_value.toLowerCase() === "exe") {
              isExe = true;
            } else if (isExe && y_value.toLowerCase() !== "done") {
              isExe = false;
              y_value = "EXE";
            }
            */

            newPoint.push(y_value);

            // Old Data model
            if (v.name) {
              pubData.Name = v.name;
            }
            if (v.Name) {
              pubData.Name = v.Name;
            }

            // Add to series
            const tmpSerie = tmp_timelineAll.find(item => item.ref_channel === v.ref);
            if (!tmpSerie) {
              const serie_name = v.ref.indexOf("/") > -1 ? "Process:" + v.ref.split("/")[2] : v.ref;
              if (pubData.Name) {
                pubData.Area = serie_name;
              }
              const tmp_newSerie = {
                serie: {
                  name: serie_name,
                  data: new Array(newPoint), // [ [ts, value], [ts, value] ..... ]
                  originalData: new Array(pubData),
                  eventsData: [],
                  id: v.ref.replace(new RegExp("/", "g"), "_")
                },
                ref_channel: v.ref,
                colors: mapProductionStateColors,
                ref_label: v.ref.replace(new RegExp("/", "g"), "_")
              };

              // Get processName
              //if (!!v.ref.split("/")[2]) {
              //}
              tmp_timelineAll.push(tmp_newSerie);
            } else {
              // Esempio di EVENTS
              /*
              if (y_value === "EXE") {
                tmpSerie.serie.eventsData.push({
                  x: ts,
                  title: "A",
                  text: "Some event with a description"
                });
              }
              */

              // Add on existing Serie
              tmpSerie.serie.data.push(newPoint);

              // Add original other info
              const newData = {};
              // Old Data model
              if (v.name) {
                newData.Name = v.name;
              }
              if (v.Name) {
                newData.Name = v.Name;
              }
              if (newData.Name) {
                newData.Area = tmpSerie.serie.name;
              }
              tmpSerie.serie.originalData.push(newData);
            }
          }
        }
      }
      // Upate state
      state.timelineAll = tmp_timelineAll;
    },
    ADD_SERIES_EVENT: (state, payload) => {
      const newSerie = {
        serie: {
          name: "",
          data: [],
          originalData: [],
          eventsData: [],
          id: ""
        },
        ref_channel: "",
        colors: mapProductionStateColors,
        ref_label: ""
      };
      const tmp_timelineAll = [];
      let currProg;
      for (let i = payload.length - 1; i >= 0; i--) {
        if (payload[i].v) {
          const y_value = payload[i].v;
          const channel = payload[i].channel;

          if (y_value) {
            const ts = new Date(payload[i].ts).getTime();

            // Add to series
            const tmpSerie = tmp_timelineAll.find(item => item.ref_channel);
            let title;

            let notification;
            if (channel.includes("Notification")) {
              title = "N";
              //currProg = "";
              notification = y_value;
            } else if (channel.includes("Name")) {
              title = "CP";
              currProg = y_value;
              notification = "";
            }
            if (!tmpSerie) {
              const tmp_newSerie = _.clone(newSerie, true);
              tmp_newSerie.serie.name = "No name";
              tmp_newSerie.ref_channel = payload[i].channel;
              tmp_newSerie.serie.id = payload[i].channel.replace(new RegExp("/", "g"), "_");
              tmp_newSerie.ref_label = payload[i].channel.replace(new RegExp("/", "g"), "_");
              tmp_newSerie.serie.eventsData.push({
                x: ts,
                title,
                text: "<b>M154 CODE</b><br>" + y_value + "<br>" + date.methods.getLocalTime(ts),
                original: y_value,
                currProg,
                notification
              });
              //tmp_newSerie.serie.id = tmp_newSerie.topic;
              tmp_timelineAll.push(tmp_newSerie);
            } else {
              tmpSerie.serie.eventsData.push({
                x: ts,
                title,
                text: "<b>M154 CODE</b><br>" + y_value + "<br>" + date.methods.getLocalTime(ts),
                original: y_value,
                currProg,
                notification
              });
            }
          }
        }
      }
      // Upate state
      state.timelineEventsAll = tmp_timelineAll;
    },
    ADD_REPS_TARGET: (state, payload) => {
      const data = {
        title: "RepsTarget",
        v: payload.v,
        label: "reps",
        ts: payload.ts
      };
      state.repsTarget = data;
    },
    ADD_REPS_DONE: (state, payload) => {
      const data = {
        title: "RepsDone",
        v: payload.v,
        label: "reps",
        ts: payload.ts
      };
      state.repsDone = data;
    },
    UPDATE_REPS_TARGET: (state, payload) => {
      state.repsTarget.v = payload.v;
      state.repsTarget.ts = payload.ts;
    },
    UPDATE_REPS_DONE: (state, payload) => {
      state.repsDone.v = payload.v;
      state.repsDone.ts = payload.ts;
    },

    UPDATE_LAST: (state, payload) => {
      state.last = payload;
    },
    RESET: state => {
      state.last = {};
      state.timelineAll = [];
      state.timelineLastPoint = {};
      state.timelineEventsAll = [];
      state.timelineEventsLastPoint = {};
      state.repsTarget = {};
      state.repsDone = {};
    }
  },
  namespaced: true,
  modules: {}
};
